export function include(valueA: string, valueB: string): boolean {
	return valueA.toUpperCase().includes(valueB.toUpperCase())
}
